<template>
  <div class="settings-card" @click="$emit('click')">
    <v-icon class="card-image" :name="$props.iconName" :scale="$props.scale"/>
    <div class="card-title">{{ $props.text }}</div>
  </div>
</template>

<script>
export default {
  name: 'SettingsCard',
  props: {
    iconName: {
      required: true,
      type: String,
    },
    text: {
      required: true,
      type: String
    },
    scale: {
      type: Number,
      default: 4,
    },
  }
}
</script>

<style lang="scss" scoped>
.settings-card {
  padding: 20px;
  margin: 0 35px 21px 0;
  height: 174px;
  width: 210px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-radius: 5px;
  background: #fff;

  &:hover {
    cursor: pointer;
  }

  .card-image {
    height: 80px;
    color: $primary;
  }

  .card-title {
    font-weight: bold;
    font-size: 16px;
    color: $primary;
  }

}
</style>